<template>
  <form class="create" v-on:submit.prevent="createCard()">
        <div v-if="!showFields">
      <textarea name="url" v-model="url" placeholder="enter URL" class="form-create-url" type="text" id="card-url-input"></textarea>
      <button class="create-url-button" @click.prevent="fetchMeta()">Get data</button>
      <a class="create-manual-input" href="javascript:void(0)" @click.prevent="showFields=true">manual input</a>
      </div>
      
      <p v-if="metad">fetching data</p>
      <div v-if="showFields" class="create-card-fields">
        <span class="card-type">{{type}}</span>
        <h5>{{source}}</h5>
        <textarea class="create-card-title" name="title" v-model="title" placeholder="Title"></textarea>
        <div class="create-pick-snippet">
            <h5>Pick a snippet</h5>
            <input type="radio" value="image" v-model="show" /><label>image</label>
            <input type="radio" value="text" v-model="show" /><label>text snippet</label>
            <input type="radio" value="" v-model="show" /><label>none</label>
        </div>
        <img :src="image" class="card-image" v-if="show === 'image'" />
        <textarea class="create-text-snippet" name="snippet" v-model="snippet" placeholder="text snippet" rows="6" v-if="show === 'text'"></textarea>
        <textarea name="description" v-model="description" placeholder="why learn this?" rows="4" class="create-card-why">
        </textarea>
        <button type="submit">+</button>
    </div>
</form>
</template>

<script>
    import getMeta from '../../data/getMeta'
    import cardRepository from '../../data/CardRepository'
    export default {
        props:['user', 'stack'],
        data () {
            return {
                type: 'link',
                title: '',
                author: '',
                description: '',
                url: '',
                image:'',
                source:'',
                snippet: '',
                icon:'',
                stackKey:'',
                length: '',
                show: 'image',
                metad: false,
                showFields: false,
            }
        },
        watch: {
        },
        mounted () {
            var that = this
            getMeta.on('metad', function(){
                that.metad = false
                that.showFields = true
            })
            getMeta.on('meta.error', function(){
                that.metad = false
                that.showFields = true
            })

            // var urlInput = document.getElementById('card-url-input');
            // var timeout = null;
            // urlInput.onkeyup = function (e) {
            //     clearTimeout(timeout);
            //     timeout = setTimeout(function () {
            //         if(that.url) {
            //             getMeta.get(that)
            //             that.metad = true
            //         } else {
            //             that.title = ''
            //             that.description = ''
            //             that.image = ''
            //             that.source = ''
            //             that.snippet = ''
            //             that.showFields = false
            //         }
            //     }, 800);
            // };
        },
        methods: {
            fetchMeta() {
                getMeta.get(this)
                this.metad = true
            },
            createCard () {
                if (this.title.trim() || this.description.trim() || this.url.trim() || this.image.trim()) {
                    if(this.stack){
                        this.stackKey = this.stack.key

                        var stackOrder
                        var stackCount

                        if(this.stack.cardCount) {
                            stackOrder = this.stack.cardCount + 1
                            stackCount = this.stack.cardCount + 1   
                        } else {
                            stackOrder = 1
                            stackCount = 1
                        }
                        
                    }
                    cardRepository.create({
                        type: this.type,
                        title: this.title, 
                        author: this.author,
                        description: this.description,
                        url: this.url,
                        image: this.image,
                        source: this.source,
                        snippet: this.snippet,
                        icon: this.icon,
                        show: this.show,
                        creator: this.user.uid, 
                        stack: this.stack,
                        length: this.length,
                        order: stackOrder,
                        stackCount: stackCount,
                        boundStack: null,
                        }, 
                        (err) => {
                            if (err) {
                                throw err
                            }


                        this.type = ''
                        this.title = ''
                        this.author = ''
                        this.description = ''
                        this.url = ''
                        this.image = ''
                        this.source = ''
                        this.snippet = ''
                        this.showFields = false
                        this.type = 'link'

                        })
                    }
                }
            }
        }
</script>

<style>
</style>


// WEBPACK FOOTER //
// Create.vue?5b784214